import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { workerStatusList, WorkerOnBoardingStatusList, WorkerDrugTestStatusList , WorkerBGVCheckStatusList } from 'shared/models/static-list-data.service';

@Component({
  selector: 'app-worker-status-lookup',
  templateUrl: './worker-status-lookup.component.html',
  styleUrls: ['./worker-status-lookup.component.css']
})
export class WorkerStatusLookupComponent implements OnInit {

  @Input() statusType = 'workerStatus';

  @Input() set resetData(isClear) {
    this.clearFromParent();
  }
  @Output() selectedWorkerStatus: EventEmitter<any> = new EventEmitter;
  selectedValue;

  workerStatuses = [];

  constructor() { }

  ngOnInit() {
    this.setWorkerStatusList(this.statusType);
    const preSelected = localStorage.getItem('filterObj');
    if (preSelected && JSON.parse(preSelected) &&
      JSON.parse(preSelected)[this.statusType] && JSON.parse(preSelected)[this.statusType].length) {
      this.selectedValue = JSON.parse(preSelected)[this.statusType];
    }
  }

  setWorkerStatusList(statusType) {
    switch (statusType) {
      case 'workerStatus':
        this.workerStatuses = workerStatusList;
        break;
      case 'workerOnBoardingStatus':
        this.workerStatuses = WorkerOnBoardingStatusList;
        break;
      case 'workerDrugTestStatus':
        this.workerStatuses = WorkerDrugTestStatusList;
        break;
      case 'workerBGVCheckStatus':
        this.workerStatuses = WorkerBGVCheckStatusList;
        break;
      default:
        this.workerStatuses = workerStatusList;
    }

  }

  onChange() {
    this.selectedWorkerStatus.emit(this.selectedValue);
  }

  clearFromParent() {
    this.selectedValue = null;
  }

}
